// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer__2S5BO","Footer_imageContainer":"Footer_imageContainer__2S5BO","Footer_image":"Footer_image__2S5BO"};